<template>
  <footer class="footer">
    <div class="footer-background">
      <div class="footer-pattern"></div>
    </div>
    
    <div class="container">
      <div class="footer-content">
        <div class="footer-brand">
          <div class="footer-logo">
            <div class="logo-icon">
              <img src="/image/logo.png" :alt="$t('nav.logoAlt')" class="logo-img">
            </div>
            <span class="logo-text">{{ $t('footer.companyFullName') }}</span>
          </div>
          <p class="brand-description">
            {{ $t('footer.brandDescription') }}
          </p>
          <div class="social-links">
            <a href="#" class="social-link" aria-label="邮箱">
              <svg class="social-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <path d="M22 6l-10 7L2 6"/>
              </svg>
            </a>
            <a href="#" class="social-link" aria-label="联系">
              <svg class="social-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </a>
            <a href="#" class="social-link" aria-label="官网">
              <svg class="social-icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
            </a>
          </div>
        </div>
        
        <div class="footer-links">
          <div class="link-group">
            <h4 class="link-title">{{ $t('footer.products') }}</h4>
            <a href="#" class="footer-link">{{ $t('footer.skillithPlatform') }}</a>
            <a href="#" class="footer-link">{{ $t('footer.smartOutsourcing') }}</a>
            <a href="#" class="footer-link">{{ $t('footer.educationIntegration') }}</a>
            <a href="#" class="footer-link">{{ $t('footer.contributionSystem') }}</a>
          </div>
          
          <div class="link-group">
            <h4 class="link-title">{{ $t('footer.about') }}</h4>
            <a href="#" class="footer-link">{{ $t('footer.companyInfo') }}</a>
            <a href="#" class="footer-link">{{ $t('footer.visionMission') }}</a>
            <a href="#" class="footer-link">{{ $t('footer.positiveSumGame') }}</a>
            <a href="#" class="footer-link">{{ $t('footer.teamInfo') }}</a>
          </div>
          
          <div class="link-group">
            <h4 class="link-title">{{ $t('footer.contact') }}</h4>
            <a href="#" class="footer-link">{{ $t('footer.nanjingOffice') }}</a>
            <a href="#" class="footer-link">{{ $t('footer.businessCooperation') }}</a>
            <a href="#" class="footer-link">{{ $t('footer.technicalSupport') }}</a>
            <a href="#" class="footer-link">{{ $t('footer.recruitment') }}</a>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <p class="copyright">
            {{ $t('footer.copyrightFull') }}
          </p>
          <div class="footer-bottom-links">
            <a href="#" class="bottom-link">{{ $t('footer.privacyPolicy') }}</a>
            <a href="#" class="bottom-link">{{ $t('footer.termsOfService') }}</a>
            <a href="#" class="bottom-link">{{ $t('footer.legalStatement') }}</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

<style scoped>
.footer {
  background:
    radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.18) 0, transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(129, 140, 248, 0.24) 0, transparent 55%),
    #020617;
  position: relative;
  overflow: hidden;
}

.footer-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

.footer-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(255, 255, 255, 0.1) 2px, transparent 2px),
    radial-gradient(circle at 75% 75%, rgba(255, 255, 255, 0.1) 2px, transparent 2px);
  background-size: 100px 100px;
  animation: pattern-move 30s linear infinite;
}

@keyframes pattern-move {
  0% { transform: translate(0, 0); }
  100% { transform: translate(100px, 100px); }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
}

.footer-content {
  padding: 4rem 0 2rem;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 4rem;
}

.footer-brand {
  color: #FFFFFF;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 1.5rem;
}

.logo-icon {
  position: relative;
  width: 40px;
  height: 40px;
}

.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0 0 14px rgba(94, 234, 212, 0.6));
}

.logo-text {
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: 1px;
}

.brand-description {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  margin-bottom: 2rem;
  font-size: 1rem;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.social-link:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.social-icon-svg {
  width: 22px;
  height: 22px;
  color: rgba(255, 255, 255, 0.85);
  transition: color 0.3s ease;
}

.social-link:hover .social-icon-svg {
  color: #fff;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

.link-group {
  color: #FFFFFF;
}

.link-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #FFFFFF;
}

.footer-link {
  display: block;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  margin-bottom: 0.8rem;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.footer-link:hover {
  color: #FFFFFF;
  transform: translateX(5px);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 2rem 0;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
}

.footer-bottom-links {
  display: flex;
  gap: 2rem;
}

.bottom-link {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s ease;
}

.bottom-link:hover {
  color: #FFFFFF;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 3rem 0 1.5rem;
  }

  .footer-links {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
  }

  .footer-bottom-content {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .footer-bottom-links {
    gap: 1rem;
  }

  .container {
    padding: 0 1rem;
  }

  .footer-brand {
    text-align: center;
  }

  .footer-logo {
    justify-content: center;
  }

  .social-links {
    justify-content: center;
  }

  .link-group {
    background: radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.16) 0, transparent 55%),
                radial-gradient(circle at 100% 100%, rgba(168, 85, 247, 0.22) 0, transparent 55%),
                rgba(15, 23, 42, 0.95);
    border-radius: 16px;
    padding: 1.25rem 0.75rem;
    border: 1px solid rgba(148, 163, 184, 0.45);
  }

  .link-title {
    text-align: center;
    margin-bottom: 0.75rem;
  }

  .footer-link {
    margin-bottom: 0.45rem;
    text-align: center;
    font-size: 0.85rem;
  }

  .footer-bottom {
    padding-top: 1.5rem;
  }
}
</style>
